// i18n/translations.js
// ─────────────────────────────────────────────────────────────────────────────
// Single source of truth for UI copy. Each entry is { en, zh }.
// Add a new string by adding one line here, then reference it with t('key').
// Keys are namespaced: common.* / pay.* / profile.* / event.* / home.*
// ─────────────────────────────────────────────────────────────────────────────
const dict = {
  // ── common ────────────────────────────────────────────────────────────────
  'common.cancel': { en: 'Cancel', zh: '取消' },
  'common.close': { en: 'Close', zh: '关闭' },
  'common.save': { en: 'Save', zh: '保存' },
  'common.edit': { en: 'Edit', zh: '编辑' },
  'common.delete': { en: 'Delete', zh: '删除' },
  'common.remove': { en: 'Remove', zh: '移除' },
  'common.clear': { en: 'Clear', zh: '清除' },
  'common.reset': { en: 'Reset', zh: '重置' },
  'common.view': { en: 'View', zh: '查看' },
  'common.preview': { en: 'Preview', zh: '预览' },
  'common.loading': { en: 'Loading...', zh: '加载中…' },
  'common.processing': { en: 'Processing...', zh: '处理中…' },
  'common.gotIt': { en: 'Got it!', zh: '知道了！' },
  'common.gotItShort': { en: 'Got it', zh: '知道了' },
  'common.readMore': { en: 'Read More', zh: '展开' },
  'common.showLess': { en: 'Show Less', zh: '收起' },
  'common.today': { en: 'Today', zh: '今天' },
  'common.required': { en: 'Required', zh: '必选' },
  'common.optional': { en: 'optional', zh: '可选' },
  'common.optionalDot': { en: '· optional', zh: '· 可选' },
  'common.all': { en: 'All', zh: '全部' },
  'common.inProgress': { en: 'In progress', zh: '进行中' },
  'common.perPerson': { en: 'per person', zh: '每人' },

  // ── language picker ─────────────────────────────────────────────────────────
  'lang.title': { en: 'Language', zh: '语言' },
  'lang.preferred': { en: 'Preferred Language', zh: '首选语言' },
  'lang.hint': { en: 'Choose how the app is displayed.', zh: '选择应用的显示语言。' },
  'lang.en': { en: '🇦🇺 English', zh: '🇦🇺 English' },
  'lang.zh': { en: '🇨🇳 中文', zh: '🇨🇳 中文' },

  // ── PayPalPayment ──────────────────────────────────────────────────────────
  'pay.eventRegistration': { en: 'Event Registration', zh: '活动报名' },
  'pay.completeBelow': { en: 'Complete payment below to secure your spot.', zh: '请完成以下付款以确认您的名额。' },
  'pay.orderSummary': { en: 'Order Summary', zh: '订单摘要' },
  'pay.payingAs': { en: 'Paying as', zh: '付款人' },
  'pay.total': { en: 'Total', zh: '合计' },
  'pay.totalAmount': { en: 'Total Amount', zh: '应付总额' },
  'pay.choosePaymentMethod': { en: 'Choose Payment Method', zh: '选择付款方式' },
  'pay.applePayNotReady': {
    en: 'Apple Pay is still loading — please wait a moment and tap the button again. No charge was made.',
    zh: 'Apple Pay 正在加载，请稍等片刻后再点击一次。本次未产生扣款。',
  },
  'pay.continueToPayment': { en: 'Continue to Payment →', zh: '继续付款 →' },
  'pay.addYourDetails': { en: 'Add your', zh: '填写您的' },
  'pay.speedUp': { en: '— your saved details will speed up checkout.', zh: '— 保存的信息可加快结账速度。' },
  'pay.emailForConfirmation': { en: 'Email for your confirmation 邮箱', zh: '确认邮件邮箱' },
  'pay.customCardPayment': { en: 'Custom Card Payment', zh: '信用卡付款' },
  'pay.nameOnCard': { en: 'Name on card', zh: '持卡人姓名' },
  'pay.cardNumber': { en: 'Card number', zh: '卡号' },
  'pay.expiry': { en: 'Expiry', zh: '有效期' },
  'pay.cancellationPolicy': { en: 'Cancellation Policy', zh: '取消政策' },
  'pay.cancellationPolicyZh': { en: 'Cancellation Policy', zh: '取消政策' },
  'pay.refundLine1': { en: '• Cancel 24+ hours before event for a full refund', zh: '• 活动开始24小时前取消可全额退款' },
  'pay.refundLine2': { en: '• No refunds within 24 hours of start time', zh: '• 活动开始24小时内不予退款' },
  'pay.refundLine3': { en: '• Refunds processed in 3–5 business days', zh: '• 退款将在3–5个工作日内处理' },
  'pay.agreeToPolicy': { en: 'I agree to the cancellation policy', zh: '我同意以上取消政策' },
  'pay.phNameOnCard': { en: 'Full name', zh: '持卡人全名' },
  'pay.phEmail': { en: 'you@example.com', zh: 'you@example.com' },

  // ── Profile ────────────────────────────────────────────────────────────────
  'profile.loading': { en: 'Loading profile...', zh: '正在加载资料…' },
  'profile.logout': { en: 'Logout', zh: '退出登录' },
  'profile.admin': { en: 'Admin', zh: '管理员' },
  'profile.administrator': { en: 'Administrator', zh: '管理员' },
  'profile.adminControls': { en: 'Admin Controls', zh: '管理控制' },
  'profile.adminPanel': { en: 'Admin Panel', zh: '管理面板' },
  'profile.fullAdminAccess': { en: 'Full admin access enabled', zh: '已启用完整管理权限' },
  'profile.allUsers': { en: 'All Users', zh: '所有用户' },
  'profile.viewing': { en: 'Viewing', zh: '正在查看' },
  'profile.viewingColon': { en: '👁 Viewing:', zh: '👁 正在查看：' },
  'profile.viewMyProfile': { en: '— View My Profile —', zh: '— 查看我的资料 —' },
  'profile.fullName': { en: 'Full Name *', zh: '姓名 *' },
  'profile.nickname': { en: 'Nickname', zh: '昵称' },
  'profile.gender': { en: 'Gender *', zh: '性别 *' },
  'profile.male': { en: 'Male', zh: '男' },
  'profile.female': { en: 'Female', zh: '女' },
  'profile.email': { en: 'Email', zh: '邮箱' },
  'profile.emailVerified': { en: 'Email Verified', zh: '邮箱已验证' },
  'profile.phone': { en: 'Phone', zh: '电话' },
  'profile.bio': { en: 'Bio', zh: '简介' },
  'profile.industry': { en: 'Industry', zh: '行业' },
  'profile.interests': { en: 'Interests', zh: '兴趣' },
  // ── Industry options ──
  'industry.Accounting': { en: 'Accounting', zh: '会计' },
  'industry.Architecture': { en: 'Architecture', zh: '建筑' },
  'industry.Automotive': { en: 'Automotive', zh: '汽车' },
  'industry.Consulting': { en: 'Consulting', zh: '咨询' },
  'industry.Construction': { en: 'Construction', zh: '建设' },
  'industry.Creative / Media': { en: 'Creative / Media', zh: '创意 / 媒体' },
  'industry.Education': { en: 'Education', zh: '教育' },
  'industry.Engineering': { en: 'Engineering', zh: '工程' },
  'industry.Finance / Banking': { en: 'Finance / Banking', zh: '金融 / 银行' },
  'industry.Food & Beverage': { en: 'Food & Beverage', zh: '餐饮' },
  'industry.Government': { en: 'Government', zh: '政府' },
  'industry.Healthcare': { en: 'Healthcare', zh: '医疗' },
  'industry.Hospitality / Tourism': { en: 'Hospitality / Tourism', zh: '酒店 / 旅游' },
  'industry.HR / Recruitment': { en: 'HR / Recruitment', zh: '人力资源' },
  'industry.Insurance': { en: 'Insurance', zh: '保险' },
  'industry.IT / Tech': { en: 'IT / Tech', zh: 'IT / 科技' },
  'industry.Legal': { en: 'Legal', zh: '法律' },
  'industry.Logistics / Supply Chain': { en: 'Logistics / Supply Chain', zh: '物流 / 供应链' },
  'industry.Manufacturing': { en: 'Manufacturing', zh: '制造业' },
  'industry.Marketing / Sales': { en: 'Marketing / Sales', zh: '市场 / 销售' },
  'industry.Mining / Resources': { en: 'Mining / Resources', zh: '矿业 / 资源' },
  'industry.Pharmaceuticals': { en: 'Pharmaceuticals', zh: '制药' },
  'industry.Real Estate': { en: 'Real Estate', zh: '房地产' },
  'industry.Retail / E-commerce': { en: 'Retail / E-commerce', zh: '零售 / 电商' },
  'industry.Student': { en: 'Student', zh: '学生' },
  'industry.Freelancer': { en: 'Freelancer / Self-employed', zh: '自由职业' },
  'industry.Retired': { en: 'Retired', zh: '退休' },
  'industry.Other': { en: 'Other', zh: '其他' },
  // ── Interest options ──
  'interest.Anime': { en: 'Anime', zh: '动漫' },
  'interest.Art & Design': { en: 'Art & Design', zh: '艺术设计' },
  'interest.Badminton': { en: 'Badminton', zh: '羽毛球' },
  'interest.Baking': { en: 'Baking', zh: '烘焙' },
  'interest.Basketball': { en: 'Basketball', zh: '篮球' },
  'interest.Board Games': { en: 'Board Games', zh: '桌游' },
  'interest.Bowling': { en: 'Bowling', zh: '保龄球' },
  'interest.Bubble Tea': { en: 'Bubble Tea', zh: '奶茶' },
  'interest.Camping': { en: 'Camping', zh: '露营' },
  'interest.Cars': { en: 'Cars', zh: '汽车' },
  'interest.Cats': { en: 'Cats', zh: '猫' },
  'interest.Chess': { en: 'Chess', zh: '国际象棋' },
  'interest.Climbing': { en: 'Climbing', zh: '攀岩' },
  'interest.Coding / Tech': { en: 'Coding / Tech', zh: '编程 / 科技' },
  'interest.Coffee': { en: 'Coffee', zh: '咖啡' },
  'interest.Cooking': { en: 'Cooking', zh: '烹饪' },
  'interest.Crafts / DIY': { en: 'Crafts / DIY', zh: '手工 / DIY' },
  'interest.Crypto': { en: 'Crypto', zh: '加密货币' },
  'interest.Cycling': { en: 'Cycling', zh: '骑行' },
  'interest.Dancing': { en: 'Dancing', zh: '跳舞' },
  'interest.Dogs': { en: 'Dogs', zh: '狗' },
  'interest.Escape Rooms': { en: 'Escape Rooms', zh: '密室逃脱' },
  'interest.Fashion': { en: 'Fashion', zh: '时尚' },
  'interest.Fishing': { en: 'Fishing', zh: '钓鱼' },
  'interest.Food & Dining': { en: 'Food & Dining', zh: '美食' },
  'interest.Gaming': { en: 'Gaming', zh: '游戏' },
  'interest.Gardening': { en: 'Gardening', zh: '园艺' },
  'interest.Golf': { en: 'Golf', zh: '高尔夫' },
  'interest.Gym / Fitness': { en: 'Gym / Fitness', zh: '健身' },
  'interest.Hiking': { en: 'Hiking', zh: '徒步' },
  'interest.Investing': { en: 'Investing', zh: '投资' },
  'interest.Karaoke': { en: 'Karaoke', zh: '唱歌 / KTV' },
  'interest.Languages': { en: 'Languages', zh: '语言学习' },
  'interest.Mahjong': { en: 'Mahjong', zh: '麻将' },
  'interest.Martial Arts': { en: 'Martial Arts', zh: '武术' },
  'interest.Movies / TV': { en: 'Movies / TV', zh: '电影 / 电视' },
  'interest.Music': { en: 'Music', zh: '音乐' },
  'interest.Photography': { en: 'Photography', zh: '摄影' },
  'interest.Podcasts': { en: 'Podcasts', zh: '播客' },
  'interest.Reading': { en: 'Reading', zh: '阅读' },
  'interest.Running': { en: 'Running', zh: '跑步' },
  'interest.Skiing / Snowboarding': { en: 'Skiing / Snowboarding', zh: '滑雪' },
  'interest.Squash': { en: 'Squash', zh: '壁球' },
  'interest.Swimming': { en: 'Swimming', zh: '游泳' },
  'interest.Table Tennis': { en: 'Table Tennis', zh: '乒乓球' },
  'interest.Tennis': { en: 'Tennis', zh: '网球' },
  'interest.Travel': { en: 'Travel', zh: '旅行' },
  'interest.Volleyball': { en: 'Volleyball', zh: '排球' },
  'interest.Volunteering': { en: 'Volunteering', zh: '志愿服务' },
  'interest.Wine & Drinks': { en: 'Wine & Drinks', zh: '品酒' },
  'interest.Yoga': { en: 'Yoga', zh: '瑜伽' },
  'profile.wechatId': { en: 'WeChat ID', zh: '微信号' },
  'profile.wechatUsername': { en: 'WeChat Username', zh: '微信用户名' },
  'profile.wechatNoEmail': { en: 'WeChat accounts have no email', zh: '微信账号没有邮箱' },
  'profile.fromWechat': { en: 'From your WeChat account · cannot be changed', zh: '来自您的微信账号 · 不可修改' },
  'profile.cannotBeChanged': { en: 'Cannot be changed', zh: '不可修改' },
  'profile.badmintonLevel': { en: 'Badminton Level', zh: '羽毛球水平' },
  'profile.selfAssessed': { en: 'Self-assessed · visible to all players', zh: '自评 · 对所有球友可见' },
  'profile.visibility': { en: 'Visibility', zh: '可见性' },
  'profile.whatOthersSee': { en: 'What others see', zh: '其他人看到的内容' },
  'profile.alwaysVisible': { en: 'Always Visible', zh: '始终可见' },
  'profile.shownEveryPlayer': { en: 'Shown to every player', zh: '对所有球友显示' },
  'profile.shownInEvent': { en: 'Shown to players in your event', zh: '对同场活动的球友显示' },
  'profile.separateName': { en: 'Separate from your real name · shown to other players', zh: '与真实姓名分开 · 对其他球友显示' },
  'profile.phoneOrWechat': { en: '(phone or WeChat ID required)', zh: '（需填写电话或微信号）' },
  'profile.completeToRegister': { en: 'Complete your profile to register for events.', zh: '请完善资料以报名活动。' },
  'profile.fillDetailsAbove': { en: 'Fill in your details above', zh: '请在上方填写您的信息' },
  'profile.filterByEvent': { en: 'Filter by Event', zh: '按活动筛选' },
  'profile.firstTime': { en: 'First Time', zh: '首次' },
  'profile.scrollToSeeAll': { en: 'Scroll to see all', zh: '滑动查看全部' },
  'profile.terms': { en: 'Terms', zh: '条款' },
  'profile.loyaltyCard': { en: 'Loyalty Card', zh: '积分卡' },
  'profile.loyaltyTerms': { en: 'Loyalty Terms · 积分条款', zh: '积分条款' },
  'profile.lifetimeRewards': { en: 'Lifetime Rewards', zh: '累计奖励' },
  'profile.progressToMajor': { en: 'Progress to Major Reward', zh: '距离大奖进度' },
  'profile.collectAll6': { en: 'Collect all 6 gift rewards (30 stamps)', zh: '集齐 6 个奖励（30 个印章）' },
  'profile.oneSessionOneStamp': { en: '1 paid session = 1 stamp', zh: '1 次付费活动 = 1 个印章' },
  'profile.readyToReset': { en: 'Ready to reset and start again', zh: '可以重置并重新开始' },
  'profile.resetRestart': { en: 'Reset & Restart', zh: '重置并重新开始' },
  'profile.major': { en: 'Major', zh: '大奖' },
  'profile.minor': { en: 'Minor', zh: '小奖' },
  'profile.addStamp': { en: 'Add Stamp', zh: '添加印章' },
  'profile.resetAllStamps': { en: '⚠️ Reset ALL Users Stamps', zh: '⚠️ 重置所有用户印章' },
  'profile.checkEmailCode': { en: 'Check your email for a 6-digit code and enter it below.', zh: '请查收邮件中的 6 位验证码并在下方输入。' },
  'profile.upcomingEvents': { en: '── Upcoming Events ──', zh: '── 即将开始的活动 ──' },
  'profile.pastEvents': { en: '── Past Events ──', zh: '── 往期活动 ──' },
  'profile.majorRewardBanner': { en: '🎉 MAJOR REWARD 🎉', zh: '🎉 大奖 🎉' },
  'profile.majorRewardRedeemed': { en: '👑 Major Reward Redeemed!', zh: '👑 大奖已兑换！' },
  // placeholders
  'profile.phYourFullName': { en: 'Your full name', zh: '您的姓名' },
  'profile.phDisplayName': { en: 'Display name at events (e.g. Panda)', zh: '活动中的昵称（例如 Panda）' },
  'profile.phOneLine': { en: 'One line about yourself', zh: '一句话介绍自己' },
  'profile.phAddEmail': { en: 'Add email (optional)', zh: '添加邮箱（可选）' },
  'profile.phPhone': { en: 'e.g. 0412 345 678', zh: '例如 0412 345 678' },
  'profile.phWechatSearch': { en: 'Your WeChat search ID', zh: '您的微信搜索号' },
  'profile.phSearchUser': { en: 'Search name or email...', zh: '搜索姓名或邮箱…' },

  // ── EventDetail ────────────────────────────────────────────────────────────
  'event.details': { en: 'Details', zh: '详情' },
  'event.description': { en: 'Description', zh: '活动介绍' },
  'event.location': { en: 'Location', zh: '地点' },
  'event.venue': { en: 'Venue', zh: '场馆' },
  'event.info': { en: 'Info', zh: '信息' },
  'event.facilities': { en: 'Facilities', zh: '设施' },
  'event.getDirections': { en: 'Get Directions', zh: '导航前往' },
  'event.registrationStatus': { en: 'Registration Status', zh: '报名状态' },
  'event.registrationOpen': { en: 'Registration Open', zh: '报名开放中' },
  'event.registrationClosed': { en: 'Registration has closed for this event', zh: '本活动报名已截止' },
  'event.registrationCancelled': { en: 'Registration Cancelled', zh: '报名已取消' },
  'event.registrationClosesLabel': { en: '- Registration closes:', zh: '- 报名截止：' },
  'event.eventFull': { en: 'Event Full', zh: '活动已满' },
  'event.eventEnded': { en: 'Event Ended', zh: '活动已结束' },
  'event.ongoing': { en: 'Ongoing', zh: '进行中' },
  'event.ongoingNotice': { en: 'This event is currently ongoing!', zh: '本活动正在进行中！' },
  'event.registered': { en: 'Registered', zh: '已报名' },
  'event.confirmed': { en: 'Confirmed', zh: '已确认' },
  'event.confirmedRegistration': { en: 'Confirmed Registration!', zh: '报名已确认！' },
  'event.cancelled': { en: 'Cancelled', zh: '已取消' },
  'event.cancelledColon': { en: 'Cancelled:', zh: '已取消：' },
  'event.cancelling': { en: 'Cancelling...', zh: '取消中…' },
  'event.cancelWaitlist': { en: 'Cancel Waitlist', zh: '取消候补' },
  'event.waitlisted': { en: 'Waitlisted', zh: '候补中' },
  'event.waitlistTab': { en: 'Waitlist', zh: '候补名单' },
  'event.positionHash': { en: 'Position #', zh: '候补第' },
  'event.positionSuffix': { en: '', zh: '位' },
  'event.notifiedWhenOpen': { en: "You'll be notified if a spot opens up.", zh: '有名额时会通知您。' },

  // ── cancellation notifications (always shown bilingual, regardless of the
  // selected lang, since these get written once into a Firestore notification
  // doc at cancellation time and should read clearly to the recipient
  // either way) ───────────────────────────────────────────────────────────
  'event.cancelledWaitlistNotif': {
    en: 'You have cancelled your waitlist position for "{eventTitle}". 您已取消"{eventTitle}"的候补排队。{guestSuffix}',
    zh: '您已取消"{eventTitle}"的候补排队。{guestSuffix}',
  },
  'event.cancelledRegistrationRefundNotif': {
    en: 'You have cancelled your registration for "{eventTitle}". Refund request has been submitted. 您已取消"{eventTitle}"的报名，退款申请已提交。{guestSuffix}',
    zh: '您已取消"{eventTitle}"的报名，退款申请已提交。{guestSuffix}',
  },
  'event.cancelledRegistrationNotif': {
    en: 'You have cancelled your registration for "{eventTitle}". 您已取消"{eventTitle}"的报名。{guestSuffix}',
    zh: '您已取消"{eventTitle}"的报名。{guestSuffix}',
  },
  // Appended to the three messages above when the cancelled registration had
  // brought guests via an "Additional Player"-style option.
  'event.cancelledGuestSuffix': {
    en: ' This also cancelled your guest{guestPlural} ({guestNames}) — {spots} spot{spotsPlural} returned to the event. 您带的球友（{guestNamesZh}）的名额也已一同取消，共归还 {spots} 个名额。',
    zh: ' 您带的球友（{guestNamesZh}）的名额也已一同取消，共归还 {spots} 个名额。',
  },
  // Admin removed a player from the event/waitlist — notification sent to
  // the affected player (AdminDashboard.js's confirmRemovePlayer).
  'event.removedByAdminNotif': {
    en: 'An admin has removed your registration for "{eventTitle}".{guestSuffix} 管理员已取消您"{eventTitle}"的报名。',
    zh: '管理员已取消您"{eventTitle}"的报名。{guestSuffix}',
  },
  'event.removedFromWaitlistByAdminNotif': {
    en: 'An admin has removed you from the waitlist for "{eventTitle}". 管理员已将您从"{eventTitle}"的候补名单中移除。',
    zh: '管理员已将您从"{eventTitle}"的候补名单中移除。',
  },

  // ── "Additional Player" capacity messaging ──────────────────────────────
  // Shown on the quantity stepper for a player-ticket option once remaining
  // event capacity (rather than the option's own configured max) becomes the
  // binding limit.
  'event.spotsLeftForGuests': {
    en: '(仅剩 {count} 个名额 only {count} spot{plural} left)',
    zh: '(仅剩 {count} 个名额)',
  },
  'event.maxQuantityLabel': {
    en: '(max 最多 {count})',
    zh: '(最多 {count})',
  },
  'event.noRoomForGuests': {
    en: '名额不足，无法带球友 Not enough spots left to bring a guest.',
    zh: '名额不足，无法带球友。',
  },
  // Server-side rejection from createPayPalOrder when there's room for the
  // player but not their full party — blocks payment before any charge.
  'event.notEnoughSpotsForParty': {
    en: 'Only {spotsAvailable} spot{plural} left — not enough room for you and your guest(s). 仅剩 {spotsAvailable} 个名额，不够容纳您和您的球友，请减少带球友数量或选择不带球友。',
    zh: '仅剩 {spotsAvailable} 个名额，不够容纳您和您的球友，请减少带球友数量或选择不带球友。',
  },

  'event.addedToWaitlist': { en: 'Added to Waitlist', zh: '已加入候补' },
  'event.successfullyWaitlisted': { en: 'Successfully Waitlisted!', zh: '已成功加入候补！' },
  'event.recentlyPromoted': { en: 'Recently Promoted!', zh: '刚刚补位成功！' },
  'event.spotOpened': { en: 'Great news! A spot has opened up!', zh: '好消息！有名额空出来了！' },
  'event.checkedIn': { en: 'Checked In', zh: '已签到' },
  'event.checkedInTick': { en: '✓ Checked In', zh: '✓ 已签到' },
  'event.signUp': { en: 'Sign up', zh: '报名' },
  'event.payNow': { en: 'Pay Now', zh: '立即付款' },
  'event.completePayment': { en: 'Complete Payment', zh: '完成付款' },
  'event.completeProfile': { en: 'Complete Profile', zh: '完善资料' },
  'event.completeProfileToRegister': { en: 'Complete your profile to register', zh: '请完善资料后报名' },
  'event.completePaymentSecure': { en: 'Complete payment to secure your spot', zh: '完成付款以确认名额' },
  'event.completePaymentBefore': { en: 'Complete payment before the event to secure your spot.', zh: '请在活动开始前完成付款以确认名额。' },
  'event.paymentStatus': { en: 'Payment Status', zh: '付款状态' },
  'event.paymentConfirmed': { en: 'Payment Confirmed', zh: '付款已确认' },
  'event.paymentPending': { en: 'Payment Pending', zh: '待付款' },
  'event.paymentRequired': { en: 'Payment Required!', zh: '需要付款！' },
  'event.paymentCompleted': { en: 'Payment completed', zh: '付款已完成' },
  'event.paymentProcessed': { en: 'Your payment has been processed', zh: '您的付款已处理完成' },
  'event.noPaymentYet': { en: 'No payment required yet', zh: '暂无需付款' },
  'event.paymentMethod': { en: 'Payment Method:', zh: '付款方式：' },
  'event.amount': { en: 'Amount:', zh: '金额：' },
  'event.totalPaid': { en: 'Total Paid:', zh: '已付总额：' },
  'event.status': { en: 'Status:', zh: '状态：' },
  'event.refundRequested': { en: 'Refund Requested', zh: '已申请退款' },
  'event.refunded': { en: 'Refunded', zh: '已退款' },
  'event.refundStatus': { en: 'Refund Status:', zh: '退款状态：' },
  'event.refundInformation': { en: 'Refund Information:', zh: '退款信息：' },
  'event.whatHappensNext': { en: 'What happens next?', zh: '接下来会怎样？' },
  'event.importantNotice': { en: 'Important Notice', zh: '重要提示' },
  'event.important': { en: 'Important:', zh: '重要：' },
  'event.participantsNone': { en: 'No participants yet', zh: '暂无参与者' },
  'event.beFirst': { en: 'Be the first to register for this event!', zh: '成为第一个报名的人吧！' },
  'event.alsoJoining': { en: 'Other upcoming bookings', zh: '即将参加' },
  'event.playedTogetherLoading': { en: 'Loading shared history...', zh: '正在加载同场记录...' },
  'event.playedTogetherCount': { en: 'Played together {count} time(s)', zh: '同场 {count} 次' },
  'event.optionalServices': { en: 'Optional Services', zh: '可选服务' },
  'event.playersTab': { en: 'Players', zh: '已报名' },
  'event.registeredPlayers': { en: 'Registered Players', zh: '已报名球友' },
  'event.canAddServices': { en: 'You can add optional services!', zh: '您可以添加可选服务！' },
  'event.modifyBeforePayment': { en: 'You can modify services before payment', zh: '付款前可修改所选服务' },
  'event.noSocialProfile': { en: "This player hasn't set up their social profile yet.", zh: '该球友还没有设置社交资料。' },
  'event.refundBullet1': { en: '• Refund will be processed to your PayPal account', zh: '• 退款将原路退回您的 PayPal 账户' },
  'event.refundBullet2': { en: '• Processing time: 3-5 business days', zh: '• 处理时间：3–5 个工作日' },
  'event.refundBullet3': { en: '• No payment was processed, so no refund needed', zh: '• 未发生付款，无需退款' },
  'event.cancelBullet1': { en: '• This action cannot be undone', zh: '• 此操作无法撤销' },
  'event.cancelBullet2': { en: '• Your spot will be given to waitlisted users', zh: '• 您的名额将分配给候补球友' },
  'event.cancelBullet3': { en: '• You can register and cancel up to twice per event', zh: '• 每个活动最多可报名和取消两次' },
  'event.waitlistBullet': { en: '• No payment is required while waitlisted', zh: '• 候补期间无需付款' },
  'event.reasonForCancel': { en: 'Reason for cancellation (optional)', zh: '取消原因（可选）' },
  'event.reasonForCancelPlaceholder': {
    en: "Help us improve by sharing why you're cancelling...",
    zh: '告诉我们取消的原因，帮助我们改进…',
  },

  // ── cancel modal: shell ───────────────────────────────────────────────────
  'event.cancelWaitlistTitle': { en: 'Cancel Waitlist', zh: '取消候补' },
  'event.cancelRegistrationTitle': { en: 'Cancel Registration', zh: '取消报名' },
  'event.cancelConfirmLead': {
    en: 'Are you sure you want to cancel your registration for',
    zh: '确定要取消以下活动的报名吗：',
  },
  'event.keepRegistration': { en: 'Keep Registration', zh: '保留报名' },
  'event.stayInWaitlist': { en: 'Stay in Waitlist', zh: '继续候补' },
  'event.cancelAndRequestRefund': { en: 'Cancel & Request Refund', zh: '取消并申请退款' },
  'event.refundAmountLabel': { en: '• Refund amount:', zh: '• 退款金额：' },

  // ── cancel modal: how many cancellations are left ─────────────────────────
  // MAX_CANCELLATIONS in utils/paypalUtils.js is the number these count down
  // from — change both together or the copy will promise the wrong thing.
  'event.cancelRemaining': {
    en: '• You can re-register after cancelling ({count} cancellation(s) remaining)',
    zh: '• 取消后你仍可重新报名（还剩 {count} 次取消机会）',
  },
  'event.cancelLastChance': {
    en: '• ⚠️ This is your last cancellation — you cannot register again after this',
    zh: '• ⚠️ 这是你最后一次取消机会，取消后无法再次报名',
  },

  // ── cancel modal: where the money goes ────────────────────────────────────
  'event.refundMethod': { en: 'Refund method', zh: '退款方式' },
  'event.refundToCredit': { en: 'Refund to account credit', zh: '退到账户余额' },
  'event.refundToCreditDesc': {
    en: 'Usually credited the same day and can be spent on your next event.',
    zh: '通常当天到账，可直接用于下次报名。',
  },
  'event.refundToOriginal': { en: 'Refund to card / PayPal', zh: '原路退回银行卡 / PayPal' },
  'event.refundToOriginalDesc': {
    en: 'Returned by PayPal to the original payment method, usually 3-5 business days.',
    zh: '由 PayPal 退回原支付方式，通常需要 3-5 个工作日。',
  },
  'event.refundFaster': { en: 'Faster', zh: '更快' },
  // Shown instead of the radio group when the registration was itself paid
  // from the wallet: there is no PayPal capture to reverse, so there is no
  // choice to offer.
  'event.refundCreditOnlyNotice': {
    en: 'This registration was paid with account credit, so the refund goes back to your credit balance.',
    zh: '此报名使用账户余额支付，退款将原路退回账户余额。',
  },
  // Replaces refundBullet1/refundBullet2 when the money is going to the
  // wallet — those two say "PayPal account" and "3-5 business days", which
  // are both wrong for a credit refund.
  'event.refundBulletCredit': {
    en: '• Refund will be returned to your account credit',
    zh: '• 退款将退回您的账户余额',
  },
  'event.refundBulletCreditTime': {
    en: '• Usually credited the same day',
    zh: '• 通常当天到账',
  },
  'event.notesLabel': { en: 'Notes 备注:', zh: '备注：' },
  'event.quantityLabel': { en: 'Quantity 数量:', zh: '数量：' },
  'event.subtotalLabel': { en: 'Subtotal 小计:', zh: '小计：' },
  'event.bringPlayer': { en: 'Bring a player', zh: '带球友' },
  'event.pickOne': { en: 'Pick one', zh: '选一项' },
  'event.validationChooseOne': { en: 'Please choose one: {options}', zh: '请选择其中一项: {options}' },
  'event.validationRequiredService': { en: 'Please select the required service: "{service}"', zh: '请选择必选服务: "{service}"' },
  'event.validationEnterNames': { en: 'Please enter {count} player name(s) for "{service}"', zh: '请填写 "{service}" 的 {count} 位球友姓名' },
  'event.validationAddonRequired': { en: 'Please select the required service "{service}" in "{addon}"', zh: '请选择 "{addon}" 的必选服务: "{service}"' },
  'event.validationAddonChooseOne': { en: 'Please choose one in "{addon}": {options}', zh: '请在 "{addon}" 中选择: {options}' },
  'event.validationAddonEnterNames': { en: 'Please enter {count} name(s) for "{service}" in "{addon}"', zh: '请填写 "{addon}" 的 "{service}" {count} 位球友姓名' },
  'event.requiredCn': { en: 'Required', zh: '必选' },
  'event.servicesCn': { en: 'Optional Services', zh: '可选服务' },
  'event.eachUnit': { en: 'each', zh: '每份' },
  'event.canSelectServicesWaitlisted': { en: "You cannot select optional services now. If promoted to the main list, they'll be included in your payment.", zh: '您现在还不能选择可选服务。如转入正式名单，这些服务可以选择，并将计入您的付款。' },
  'event.addedPlayerNamesLabel': { en: 'Added player name(s)', zh: '同行球友姓名' },
  'event.playerNamesLabel': { en: 'Player Names', zh: '球友姓名' },
  'event.playerNamesPlaceholder': { en: 'Type a name, then press Enter ({count} more needed)', zh: '输入姓名后按回车（还需 {count} 个）' },
  'event.addNameButton': { en: 'Add', zh: '添加' },
  'event.playerNamesHint': {
    en: "Each added player needs a name — they'll appear in the players list.",
    zh: '每位同行球友都需填写姓名，将显示在球员名单中。',
  },

  // ── Home ───────────────────────────────────────────────────────────────────
  'home.allEvents': { en: 'All Events', zh: '全部活动' },
  'home.allLocations': { en: 'All Locations', zh: '全部场馆' },
  'home.byWeek': { en: 'By Week', zh: '按周' },
  'home.byMonth': { en: 'By Month', zh: '按月' },
  'home.pastEvents': { en: 'Past Events', zh: '往期活动' },
  'home.noEventsFound': { en: 'No Events Found', zh: '未找到活动' },
  'home.noPastEvents': { en: 'No past events found', zh: '没有往期活动' },
  'home.full': { en: 'Full', zh: '已满' },
  'home.registeredTick': { en: '✓ Registered', zh: '✓ 已报名' },
  'home.waitlistedHourglass': { en: '⏳ Waitlisted', zh: '⏳ 候补中' },
  'home.shareAllUpcoming': { en: 'Share All Upcoming', zh: '分享全部活动' },
  'home.copyToClipboard': { en: 'Copy to Clipboard', zh: '复制到剪贴板' },
  'home.editBeforeCopy': { en: 'Edit the message below before copying', zh: '复制前可编辑下方内容' },
  'home.createEvents': { en: 'Create Events', zh: '创建活动' },
  'home.editEvent': { en: 'Edit Event', zh: '编辑活动' },
  'home.deleteEvent': { en: 'Delete Event', zh: '删除活动' },
  'home.title': { en: 'Title', zh: '标题' },
  'home.venue': { en: 'Venue', zh: '场馆' },
  'home.selectVenue': { en: 'Select a venue', zh: '请选择场馆' },
  'home.startDate': { en: 'Start Date', zh: '开始时间' },
  'home.endDate': { en: 'End Date', zh: '结束时间' },
  'home.maxParticipants': { en: 'Max Participants', zh: '人数上限' },
  'home.price': { en: 'Price ($)', zh: '价格（$）' },
  'home.description': { en: 'Description', zh: '活动介绍' },
  'home.notes': { en: 'Notes', zh: '备注' },
  'home.organizer': { en: 'Organizer', zh: '组织者' },
  'home.courts': { en: 'Courts', zh: '场地' },
  'home.additionalServices': { en: 'Additional Services', zh: '附加服务' },
  'home.enableServices': { en: 'Enable Services', zh: '启用服务' },
  'home.addService': { en: '+ Add Service', zh: '+ 添加服务' },
  'home.addPlayerTicket': { en: '+ Add Player Ticket', zh: '+ 添加球友票' },
  'home.totalEvents': { en: 'Total Events', zh: '活动总数' },
  'home.totalBookings': { en: 'Total Bookings', zh: '报名总数' },
  'home.totalViews': { en: 'Total Views', zh: '浏览总数' },
  'home.totalRevenue': { en: 'Revenue', zh: '收入' },
  'home.avgBookings': { en: 'Avg Bookings', zh: '平均报名' },
  'home.joined': { en: 'joined', zh: '报名' },
  'home.views': { en: 'views', zh: '浏览' },
  'home.calendarView': { en: 'Calendar', zh: '日历' },
  'home.listView': { en: 'List', zh: '列表' },
  'home.eventsOnDay': { en: 'Events on', zh: '活动日期：' },
  'home.noEventsThisDay': { en: 'No events on this day', zh: '当天没有活动' },
  'home.moreEvents': { en: 'more', zh: '更多' },
  'home.zhEdit': { en: '修改', zh: '修改' },
  'home.zhShare': { en: '分享', zh: '分享' },
  'home.zhDelete': { en: '删除', zh: '删除' },

  // ── Add-on Events (admin edit + player-facing) ─────────────────────────
  'home.addonEvents': { en: 'Add-on Events', zh: '附加活动' },
  'home.addonEventsHint': { en: 'Players can choose to register for these too', zh: '球员可以选择同时报名这些活动' },
  'home.addonSelectEvent': { en: 'Select an event…', zh: '选择一个活动…' },
  'home.addonSameDay': { en: 'same day', zh: '同天' },
  'home.addonLabel': { en: 'Label', zh: '显示名称' },
  'home.addonPrice': { en: 'Price $', zh: '价格 $' },
  'home.addonAdd': { en: '+ Add an event', zh: '+ 添加活动' },
  'home.addonAlreadyBundled': { en: 'already linked', zh: '已关联' },
  'event.addonEvents': { en: 'Add-on Events', zh: '附加活动' },
  'event.addonEventsDesc': { en: 'Select to register and pay together', zh: '选择后可一起支付报名' },
  'event.addonSelected': { en: '✓ Selected', zh: '✓ 已选择' },
  'event.addonTapToAdd': { en: 'Tap to add', zh: '点击添加' },
  'event.addonJoined': { en: 'joined', zh: '报名' },
  'event.addonSpotsLeft': { en: '{count} spots left', zh: '剩余{count}个名额' },
  'event.addonFull': { en: 'Full', zh: '已满' },
  'event.addonNoPlayers': { en: 'No players yet', zh: '暂无球员' },
  'event.addonServices': { en: 'Services', zh: '附加服务' },
  'pay.addonEvent': { en: 'Add-on', zh: '附加活动' },
  'event.bannerMessage': { en: 'Having trouble completing your payment, or already paid and don\'t see your registration? Let us know and we\'ll sort it out.', zh: '支付遇到问题，或已付款但未显示报名信息？请联系我们帮您处理。' },
  'event.bannerHelp': { en: 'I need help', zh: '我需要帮助' },
  'event.bannerDismiss': { en: 'I don\'t want to register', zh: '不想报名了' },
  'share.copyLanguageHint': { en: 'Choose language for the copied message', zh: '选择复制内容的语言' },

  // ── Share Modal ──────────────────────────────────────────────────────────
  'share.title': { en: 'Share Event', zh: '分享活动' },
  'share.spotsLeft': { en: '{count} spots left', zh: '剩 {count} 个名额' },
  'share.full': { en: 'Full', zh: '已满' },
  'share.capacity': { en: '{current}/{max} registered', zh: '已报名 {current}/{max}' },
  'share.chooseMethod': { en: 'Choose how to share', zh: '选择分享方式' },
  'share.methodNative': { en: 'Share', zh: '分享' },
  'share.methodNativeDesc': { en: "Use your device's native sharing", zh: '使用设备自带的分享功能' },
  'share.methodCopy': { en: 'Copy Details & Link', zh: '复制详情和链接' },
  'share.methodCopyDesc': { en: 'Copy event details with registration link', zh: '复制活动详情和报名链接' },
  'share.methodQr': { en: 'QR Code', zh: '二维码' },
  'share.methodQrDesc': { en: 'Generate QR code for easy scanning', zh: '生成二维码方便扫描' },
  'share.methodWechat': { en: 'Share in WeChat', zh: '分享到微信' },
  'share.methodWechatDesc': { en: 'Send to friends or Moments', zh: '发送给朋友或朋友圈' },
  'share.back': { en: 'Back to share options', zh: '返回分享选项' },
  'share.qrHeading': { en: 'Scan to View Event', zh: '扫码查看活动' },
  'share.qrGenerating': { en: 'Generating QR code…', zh: '正在生成二维码…' },
  'share.qrHint': { en: 'Scan with any QR code reader to open the event page', zh: '用任意扫码工具扫描即可打开活动页面' },
  'share.qrDownload': { en: 'Download QR Code', zh: '下载二维码' },
  'share.qrFailed': { en: 'Failed to generate QR code', zh: '生成二维码失败' },
  'share.tryAgain': { en: 'Try Again', zh: '重试' },
  'share.wechatHeading': { en: 'Share in WeChat', zh: '分享到微信' },
  'share.wechatInstructionEn': { en: 'Tap the ••• menu at the top-right corner, then choose "Send to Friends" or "Moments".', zh: '' },
  'share.wechatInstructionZh': { en: '点击右上角 ••• 菜单，选择「发送给朋友」或「分享到朋友圈」。', zh: '点击右上角 ••• 菜单，选择「发送给朋友」或「分享到朋友圈」。' },
  'share.orCopyHint': { en: 'Or copy the event details and paste them into any chat:', zh: '或复制活动详情粘贴到任意聊天中：' },
  'share.eventLink': { en: 'Event link', zh: '活动链接' },
  'share.copyDetailsAndLink': { en: 'Copy details & link', zh: '复制详情和链接' },
  'share.footerTagline': { en: 'Share this event with friends and badminton enthusiasts! 🏸', zh: '快分享给球友们吧！🏸' },
  'share.copiedToClipboard': { en: 'Event details copied to clipboard!', zh: '活动详情已复制到剪贴板！' },
  'share.copiedForWechat': { en: 'Copied! Paste it into a WeChat chat or Moments.', zh: '已复制！粘贴到微信聊天或朋友圈即可。' },
  'share.errorCopying': { en: 'Error copying event', zh: '复制失败' },
  'share.errorSharing': { en: 'Error sharing event', zh: '分享失败' },
  'share.qrDownloaded': { en: 'QR code downloaded!', zh: '二维码已下载！' },
  'share.errorDownloadingQr': { en: 'Error downloading QR code', zh: '下载二维码失败' },

  // ── players tab ─────────────────────────────────────────────────────────
  'players.title': { en: 'Players', zh: '球友' },
  'players.search': { en: 'Search players...', zh: '搜索球友...' },
  'players.refresh': { en: 'Refresh', zh: '刷新' },
  'players.count': { en: 'players', zh: '位球友' },
  'players.noPlayers': { en: 'No co-players yet', zh: '还没有一起打过球的球友' },
  'players.noPlayersHint': { en: 'Players from your events will appear here', zh: '参加活动后，同场球友会显示在这里' },
  'players.noMatch': { en: 'No matching players', zh: '没有找到匹配的球友' },
  'players.gamesTogether': { en: 'games together', zh: '同场' },
  'players.gamesUnit': { en: '', zh: '次' },
  'players.today': { en: 'today', zh: '今天' },
  'players.dAgo': { en: 'd ago', zh: '天前' },
  'players.wAgo': { en: 'w ago', zh: '周前' },
  'players.longTimeAgo': { en: 'long time ago 😢', zh: '好久没打了 😢' },
  'players.upcoming': { en: 'upcoming', zh: '场即将参加' },
  'players.checkUpcoming': { en: 'upcoming?', zh: '查看即将' },
  'players.checking': { en: 'checking', zh: '查询中' },
  'players.noUpcoming': { en: 'no upcoming', zh: '无即将活动' },
  'players.lookingForPartner': { en: 'Looking for partner', zh: '找搭档' },
  'players.join': { en: 'Join →', zh: '一起去 →' },
  'players.view': { en: 'View →', zh: '查看 →' },
  'players.youAreIn': { en: "you're in", zh: '你也报名了' },
  'players.clear': { en: 'Clear', zh: '清除' },

  // ── players loading ─────────────────────────────────────────────────────
  'players.loading': { en: 'Loading player data...', zh: '加载球友数据中...' },
  'players.loadStep1': { en: 'Reading event history...', zh: '读取活动记录...' },
  'players.loadStep2': { en: 'Finding co-players...', zh: '查找同场球友...' },
  'players.loadStep3': { en: 'Loading player & event data...', zh: '加载球友和活动数据...' },
  'players.loadStep4': { en: 'Finalizing...', zh: '整理数据中...' },

  // ── leaderboard & achievements ──────────────────────────────────────────
  'players.topPartners': { en: '🏆 Top Partners', zh: '🏆 最佳搭档' },
  'players.starredActivity': { en: '⭐ Starred Activity', zh: '⭐ 收藏球友动态' },
  'players.joined': { en: 'joined', zh: '报名了' },

  // ── invite system ───────────────────────────────────────────────────────
  'invite.yourEvents': { en: 'Invite to Your Events', zh: '邀请参加你的活动' },
  'invite.see': { en: 'See →', zh: '查看 →' },
  'invite.send': { en: 'Invite', zh: '喊TA来' },
  'invite.registered': { en: 'registered', zh: '已报名' },
  'invite.limitReached': { en: 'Limit reached', zh: '已达上限' },
  'invite.limitSame': { en: 'Already invited 3 times today', zh: '今日已邀请该球友 3 次，明天再试吧' },
  'invite.limitDaily': { en: 'Daily limit reached (10/day)', zh: '今日邀请已达上限（10 次/天）' },
  'invite.sent': { en: 'Invited', zh: '已邀请' },
  'invite.failed': { en: 'Failed to send, try again', zh: '发送失败，请稍后再试' },
  'invite.goToEvent': { en: 'Go to Event →', zh: '前往活动 →' },
  'invite.later': { en: 'Later', zh: '稍后' },
  'invite.invitedYou': { en: 'invited you to', zh: '邀请你参加' },

  // ── looking for partner ─────────────────────────────────────────────────
  'lfp.title': { en: 'Looking for Partner', zh: '找搭档' },
  'lfp.toggle': { en: "I'm looking for a partner", zh: '我正在找搭档' },
  'lfp.placeholder': { en: 'e.g. Looking for doubles partner, same-level rally...', zh: '例如：找双打搭档、找同水平练球...' },

  // ── cancel & re-register ────────────────────────────────────────────────
  'cancel.maxReached': { en: "You've cancelled twice and cannot register again for this event.", zh: '你已经取消过2次，无法再次报名此活动' },
  'cancel.warningBanner': { en: 'You have cancelled twice and cannot register for this event again.', zh: '你已经取消过2次，无法再次报名此活动。' },
  'cancel.lastChance': { en: '⚠️ This is your last cancellation — you cannot register again after this', zh: '⚠️ 这是你最后一次取消机会，取消后无法再次报名' },
  'cancel.canReRegister': { en: 'You can re-register after cancelling', zh: '取消后你仍可重新报名' },
  'cancel.remaining': { en: 'cancellation remaining', zh: '次取消机会' },
  'cancel.countInfo': { en: 'You can still register again.', zh: '你仍可以重新报名。' },

  // ── waitlist ────────────────────────────────────────────────────────────
  'waitlist.position': { en: "You're currently", zh: '你目前排在第' },
  'waitlist.onWaitlist': { en: 'on the waitlist', zh: '位' },
  'waitlist.autoMove': { en: "When a spot opens, you'll be moved up automatically", zh: '有人取消时，你将自动转入正式名单' },
  'waitlist.payLater': { en: 'Payment is only needed after you get a confirmed spot', zh: '转入正式名单后才需要付款' },
  'waitlist.notifyWhenAvailable': { en: "We'll notify you when a spot is available", zh: '有名额时会通知你，并引导你完成付款流程' },

  // ── waitlist promotion modal (Home.js) ──────────────────────────────────
  'promote.title': { en: 'Capacity Increased', zh: '容量已增加' },
  'promote.capacity': { en: 'Capacity', zh: '容量变化' },
  'promote.newSpots': { en: 'New spots', zh: '新增空位' },
  'promote.onWaitlist': { en: 'On waitlist', zh: '候补等待中' },
  'promote.paidEvent': { en: '💰 Paid Event', zh: '💰 付费活动' },
  'promote.paidDesc': { en: 'will receive email + app notification. They must pay before event starts. They can also choose optional services.', zh: '位候补将收到邮件和App通知，需在活动开始前付款确认。超时未付则名额给下一位。转正后可选择可选服务。' },
  'promote.freeEvent': { en: '🆓 Free Event', zh: '🆓 免费活动' },
  'promote.freeDesc': { en: 'will be moved directly to registered.', zh: '位候补将直接转入已报名名单。' },
  'promote.notNow': { en: 'Not Now', zh: '暂不通知' },
  'promote.notify': { en: 'Notify', zh: '通知' },
  'promote.success': { en: 'player(s) promoted!', zh: '位候补球友已通知！' },
  'promote.waitingPayment': { en: 'Waiting for payment.', zh: '等待付款确认。' },
  'promote.movedToRegistered': { en: 'Moved to registered.', zh: '已直接转正。' },

  // ── detail modal ────────────────────────────────────────────────────────
  'detail.playedTogether': { en: 'Played together', zh: '同场' },
  'detail.times': { en: 'time', zh: '次' },
  'detail.upcomingEvents': { en: 'Upcoming Events', zh: '即将参加的活动' },
  'detail.pastOnly': { en: 'past', zh: '已结束' },

  // ── admin filters ───────────────────────────────────────────────────────
  'admin.sourceAll': { en: 'All', zh: '全部' },
  'admin.sourceWechat': { en: 'WeChat', zh: '微信' },
  'admin.sourceOther': { en: 'Other', zh: '其他' },
  'admin.source': { en: 'Source:', zh: '来源：' },
  'admin.searchUser': { en: 'Search User', zh: '搜索用户' },
  'admin.typeNameEmail': { en: 'Type name or email...', zh: '输入姓名或邮箱...' },

  // ── timeline chart ──────────────────────────────────────────────────────
  'timeline.title': { en: 'Registration Timeline', zh: '报名时间线' },
  'timeline.view': { en: '📊 Timeline View', zh: '📊 时间线视图' },
  'timeline.registrations': { en: 'registrations', zh: '人报名' },
  'timeline.signups': { en: 'signups at', zh: '人报名于' },
  'timeline.eventStart': { en: 'Event start', zh: '活动开始' },
  'timeline.beforeEvent': { en: 'before event', zh: '活动开始前' },

  // ── Auth: Login / Register / ForgotPassword ───────────────────────────────
  'auth.welcomeBack': { en: 'Welcome back', zh: '欢迎回来' },
  'auth.signInSubtitle': { en: 'Sign in to your badminton club account', zh: '登录您的羽毛球俱乐部账户' },
  'auth.signingInGoogle': { en: 'Signing in with Google...', zh: '正在使用 Google 登录…' },
  'auth.continueWithGoogle': { en: 'Continue with Google', zh: '使用 Google 登录' },
  'auth.orContinueWith': { en: 'Or continue with', zh: '或使用以下方式' },
  'auth.emailAddress': { en: 'Email address', zh: '邮箱地址' },
  'auth.emailAddressReq': { en: 'Email Address *', zh: '邮箱地址 *' },
  'auth.password': { en: 'Password', zh: '密码' },
  'auth.passwordReq': { en: 'Password *', zh: '密码 *' },
  'auth.confirmPasswordReq': { en: 'Confirm Password *', zh: '确认密码 *' },
  'auth.phEnterEmail': { en: 'Enter your email', zh: '请输入邮箱' },
  'auth.phEnterEmailAddress': { en: 'Enter your email address', zh: '请输入您的邮箱地址' },
  'auth.phEnterPassword': { en: 'Enter your password', zh: '请输入密码' },
  'auth.phConfirmPassword': { en: 'Confirm your password', zh: '请再次输入密码' },
  'auth.phFullName': { en: 'Enter your full name', zh: '请输入您的姓名' },
  'auth.phPhone': { en: 'Your phone number', zh: '您的电话号码' },
  'auth.phWechat': { en: 'Your WeChat ID', zh: '您的微信号' },
  'auth.rememberMe': { en: 'Remember me', zh: '记住我' },
  'auth.rememberMeInfo': { en: "You'll stay signed in on this device until you manually sign out.", zh: '您将在此设备上保持登录，直到手动退出。' },
  'auth.forgotPassword': { en: 'Forgot your password?', zh: '忘记密码？' },
  'auth.signingIn': { en: 'Signing in...', zh: '登录中…' },
  'auth.signIn': { en: 'Sign in', zh: '登录' },
  'auth.signUp': { en: 'Sign up', zh: '注册' },
  'auth.noAccount': { en: "Don't have an account?", zh: '还没有账户？' },
  'auth.haveAccount': { en: 'Already have an account?', zh: '已有账户？' },
  'auth.agreeSignIn': { en: 'By signing in, you agree to our', zh: '登录即表示您同意我们的' },
  'auth.termsPrivacy': { en: 'Terms & Privacy Policy', zh: '条款与隐私政策' },
  'auth.createAccountTitle': { en: 'Create your account', zh: '创建账户' },
  'auth.joinCommunity': { en: 'Join the badminton club community', zh: '加入羽毛球俱乐部社区' },
  'auth.personalInfo': { en: 'Personal Information', zh: '个人信息' },
  'auth.selectGender': { en: 'Select Gender', zh: '请选择性别' },
  'auth.contactInfo': { en: 'Contact Information', zh: '联系方式' },
  'auth.contactHint': { en: 'Please provide either a phone number or WeChat ID so we can contact you about events.', zh: '请填写电话号码或微信号，方便我们就活动与您联系。' },
  'auth.phoneNumber': { en: 'Phone Number', zh: '电话号码' },
  'auth.security': { en: 'Security', zh: '账户安全' },
  'auth.atLeast6Chars': { en: 'At least 6 characters', zh: '至少 6 个字符' },
  'auth.reqUppercase': { en: 'One uppercase letter', zh: '一个大写字母' },
  'auth.reqLowercase': { en: 'One lowercase letter', zh: '一个小写字母' },
  'auth.reqNumber': { en: 'One number', zh: '一个数字' },
  'auth.strengthWeak': { en: 'Weak', zh: '弱' },
  'auth.strengthFair': { en: 'Fair', zh: '一般' },
  'auth.strengthGood': { en: 'Good', zh: '良好' },
  'auth.strengthStrong': { en: 'Strong', zh: '强' },
  'auth.passwordsMatch': { en: 'Passwords match', zh: '密码一致' },
  'auth.passwordsDontMatch': { en: "Passwords don't match", zh: '密码不一致' },
  'auth.iAgreeTo': { en: 'I agree to the', zh: '我同意' },
  'auth.termsOfService': { en: 'Terms of Service', zh: '服务条款' },
  'auth.and': { en: 'and', zh: '和' },
  'auth.privacyPolicy': { en: 'Privacy Policy', zh: '隐私政策' },
  'auth.creatingAccount': { en: 'Creating Account...', zh: '正在创建账户…' },
  'auth.createAccount': { en: 'Create Account', zh: '创建账户' },
  'auth.checkYourEmail': { en: 'Check your email', zh: '请查收邮件' },
  'auth.sentInstructions': { en: "We've sent password reset instructions to your email", zh: '我们已将密码重置说明发送到您的邮箱' },
  'auth.forgotSubtitle': { en: "Enter your email address and we'll send you a link to reset your password", zh: '输入您的邮箱地址，我们将发送重置密码的链接' },
  'auth.whatsNext': { en: "What's next?", zh: '接下来' },
  'auth.resetStep1': { en: 'Check your email inbox (and spam folder)', zh: '查看邮箱收件箱（以及垃圾邮件文件夹）' },
  'auth.resetStep2': { en: 'Click the "Reset Password" link in the email', zh: '点击邮件中的"Reset Password"链接' },
  'auth.resetStep3': { en: 'Create a new password and sign in', zh: '设置新密码并登录' },
  'auth.resending': { en: 'Resending...', zh: '重新发送中…' },
  'auth.resendEmail': { en: 'Resend Email', zh: '重新发送邮件' },
  'auth.backToSignIn': { en: 'Back to Sign In', zh: '返回登录' },
  'auth.didntReceive': { en: "Didn't receive the email? Check your spam folder or", zh: '没收到邮件？请检查垃圾邮件文件夹，或' },
  'auth.tryDifferentEmail': { en: 'try a different email address', zh: '换一个邮箱地址' },
  'auth.tryGoogleInstead': { en: 'Try Google Sign-In Instead', zh: '试试 Google 登录' },
  'auth.googleHintBody': { en: 'If you originally signed up with Google, you\'ll need to use "Continue with Google" on the login page instead of resetting a password.', zh: '如果您最初是用 Google 注册的，请在登录页使用"使用 Google 登录"，无需重置密码。' },
  'auth.goToLogin': { en: 'Go to Login Page', zh: '前往登录页' },
  'auth.sendingReset': { en: 'Sending Reset Email...', zh: '正在发送重置邮件…' },
  'auth.sendReset': { en: 'Send Password Reset Email', zh: '发送密码重置邮件' },
  'auth.cantReset': { en: "Can't reset your password?", zh: '无法重置密码？' },
  'auth.cantResetBody': { en: 'If you signed up with Google, use "Continue with Google" instead. Password reset only works for accounts created with email and password.', zh: '如果您是用 Google 注册的，请直接使用"使用 Google 登录"。密码重置仅适用于通过邮箱和密码创建的账户。' },
  'auth.resetEmailSentMsg': { en: 'Check your email for password reset instructions', zh: '请查收邮件中的密码重置说明' },
  'auth.resentMsg': { en: 'Reset email sent again. Check your inbox.', zh: '重置邮件已重新发送，请查收收件箱。' },
  // auth errors (incl. Firebase error-code mappings)
  'auth.errUserNotFound': { en: 'No account found with this email address', zh: '该邮箱未注册账户' },
  'auth.errWrongPassword': { en: 'Incorrect password', zh: '密码错误' },
  'auth.errInvalidEmail': { en: 'Invalid email address', zh: '邮箱地址无效' },
  'auth.errTooManyAttempts': { en: 'Too many failed attempts. Please try again later', zh: '失败次数过多，请稍后再试' },
  'auth.errTooManyRequests': { en: 'Too many requests. Please try again later', zh: '请求过于频繁，请稍后再试' },
  'auth.errUserDisabled': { en: 'This account has been disabled', zh: '该账户已被停用' },
  'auth.errInvalidCredential': { en: 'Invalid email or password', zh: '邮箱或密码错误' },
  'auth.errLoginFailed': { en: 'Failed to login. Please check your credentials.', zh: '登录失败，请检查您的邮箱和密码。' },
  'auth.errGoogleFailed': { en: 'Google login failed. Please try again.', zh: 'Google 登录失败，请重试。' },
  'auth.errPasswordsNoMatch': { en: 'Passwords do not match', zh: '两次输入的密码不一致' },
  'auth.errPasswordTooShort': { en: 'Password must be at least 6 characters long', zh: '密码长度至少为 6 个字符' },
  'auth.errContactRequired': { en: 'Please provide either a phone number or WeChat ID', zh: '请填写电话号码或微信号' },
  'auth.errGenderRequired': { en: 'Please select your gender', zh: '请选择您的性别' },
  'auth.errEmailInUse': { en: 'An account with this email already exists', zh: '该邮箱已注册账户' },
  'auth.errWeakPassword': { en: 'Password is too weak', zh: '密码强度太弱' },
  'auth.errSignupFailed': { en: 'Failed to create account. Please try again.', zh: '创建账户失败，请重试。' },
  'auth.errEnterEmail': { en: 'Please enter your email address', zh: '请输入您的邮箱地址' },
  'auth.errValidEmail': { en: 'Please enter a valid email address', zh: '请输入有效的邮箱地址' },
  'auth.errResetUnavailable': { en: 'Unable to reset password for this account. If you signed up with Google, please use "Continue with Google" on the login page.', zh: '无法为该账户重置密码。如果您是用 Google 注册的，请在登录页使用"使用 Google 登录"。' },
  'auth.errResendFailed': { en: 'Failed to resend email. Please try again.', zh: '重新发送失败，请重试。' },

  // ── EventDetail: player-facing notifications & buttons ──────────────────────
  'event.notifPaymentExpired': { en: 'Payment deadline expired. You have been moved back to the waitlist.', zh: '付款期限已过，您已被移回候补名单。' },
  'event.notifRefreshFailed': { en: 'Unable to refresh registration status. Please try refreshing the page.', zh: '无法刷新报名状态，请刷新页面重试。' },
  'event.notifMovedBackToWaitlist': { en: 'You have been moved back to the waitlist.', zh: '您已被移回候补名单。' },
  'event.notifStatusUpdateError': { en: 'Error updating registration status. Please refresh the page.', zh: '更新报名状态出错，请刷新页面。' },
  'event.notifPaymentRequired': { en: 'Payment required before the event. Please complete payment to secure your spot.', zh: '活动开始前需要付款，请完成付款以确认名额。' },
  'event.notifCompleteProfileFirst': { en: 'Please complete your profile before registering for events.', zh: '报名活动前请先完善个人资料。' },
  'event.notifRegistrationFailed': { en: 'Registration failed. Please try again.', zh: '报名失败，请重试。' },
  'event.notifAddedToWaitlist': { en: 'Added to waitlist! No payment required until you get a confirmed spot.', zh: '已加入候补名单！确认名额前无需付款。' },
  'event.notifJoinWaitlistFailed': { en: 'Failed to join waitlist. Please try again.', zh: '加入候补失败，请重试。' },
  'event.notifPaymentDataIncomplete': { en: 'Payment completed but data incomplete. Please contact support.', zh: '付款已完成，但数据不完整，请联系管理员。' },
  'event.notifPaymentSuccessPromoted': { en: 'Payment successful! You are now confirmed for the event.', zh: '付款成功！您的名额已确认。' },
  'event.notifPaymentSuccess': { en: 'Payment successful! You are registered for the event.', zh: '付款成功！您已成功报名。' },
  'event.notifPaymentSuccessRefresh': { en: "Payment successful! Please refresh the page if status doesn't update.", zh: '付款成功！如状态未更新，请刷新页面。' },
  'event.notifPaymentFailed': { en: 'Payment failed. Please try again.', zh: '付款失败，请重试。' },
  'event.notifCancelledRefund': { en: 'Registration cancelled. Refund request submitted and will be processed by admin.', zh: '报名已取消，退款申请已提交，将由管理员处理。' },
  'event.notifCancelled': { en: 'Registration cancelled successfully.', zh: '报名已成功取消。' },
  'event.notifCancelError': { en: 'Error cancelling registration. Please try again.', zh: '取消报名出错，请重试。' },
  'event.notifCheckinSuccess': { en: 'Successfully checked in to the event!', zh: '签到成功！' },
  'event.notifCheckinError': { en: 'Error updating check-in status', zh: '更新签到状态出错' },
  'event.dismissNoticeTitle': { en: 'Dismiss this notice?', zh: '关闭此提示？' },
  'event.dismissNoticeBody': { en: "This will hide the payment issue prompt for this event. If you've already messaged the admin about it, they'll see that you've marked it as resolved.", zh: '这将隐藏本活动的付款问题提示。如果您已就此联系过管理员，管理员会看到您已将其标记为已解决。' },
  'event.goBack': { en: 'Go back', zh: '返回' },
  'event.dismissing': { en: 'Dismissing…', zh: '正在关闭…' },
  'event.yesDismiss': { en: 'Yes, dismiss', zh: '确定关闭' },
  'event.promotedServicesHint': { en: "Since you were recently promoted from the waitlist, you can still select optional services. They'll be included in your payment total.", zh: '由于您刚从候补转入正式名单，仍可选择可选服务，费用将计入付款总额。' },
  'event.paidServicesHint': { en: 'Your registration is confirmed. Optional services can only be added during initial registration.', zh: '您的报名已确认。可选服务只能在首次报名时添加。' },
  'event.updatedTotalCost': { en: 'Updated Total Cost', zh: '更新后的总费用' },
  'event.totalCost': { en: 'Total Cost', zh: '总费用' },
  'event.pending': { en: 'Pending', zh: '待付款' },
  'event.profileDetailsNeeded': { en: 'We need a few details (name, gender, and a phone or WeChat ID) before you can join events.', zh: '报名活动前，我们需要您提供一些信息（姓名、性别，以及电话或微信号）。' },
  'event.multiDiscountSave': { en: 'Save ${amount}!', zh: '立省 ${amount}！' },
  'event.updating': { en: 'Updating...', zh: '更新中…' },
  'event.ongoingSuffix': { en: ' (Event Ongoing)', zh: '（活动进行中）' },
  'event.joinWaitlist': { en: 'Join Waitlist', zh: '加入候补' },
  'event.registerNowPrice': { en: 'Register Now - ${price}', zh: '立即报名 - ${price}' },
  'event.spaceAvailableBody': { en: "You're currently waitlisted but there's now space available. Click below to secure your spot!", zh: '您目前在候补名单中，但现在有空位了。点击下方按钮确认您的名额！' },
  'event.claimSpotPrice': { en: 'Claim Your Spot - ${price}', zh: '确认名额 - ${price}' },
  'event.registerForEvent': { en: 'Register for Event', zh: '报名活动' },
  'event.loginToJoinWaitlistHint': { en: 'Login to join the waitlist and get notified when spots open up', zh: '登录后即可加入候补，有名额时会通知您' },
  'event.loginToRegisterHint': { en: 'Login to register for this event - ${price} per person', zh: '登录后即可报名本活动 - 每人 ${price}' },
  'event.loginToJoinWaitlist': { en: 'Login to Join Waitlist', zh: '登录后加入候补' },
  'event.loginToRegister': { en: 'Login to Register', zh: '登录后报名' },
  'event.processingPayment': { en: 'Processing your payment…', zh: '正在处理您的付款…' },
  'event.dontClose': { en: "Please don't close this window or refresh the page.", zh: '请勿关闭此窗口或刷新页面。' },
  'event.refundProcessing': { en: 'Processing', zh: '处理中' },
  'event.eventsAttended': { en: '{count} events attended', zh: '已参加 {count} 场活动' },

  // ── MyEvents ───────────────────────────────────────────────────────────────
  'myEvents.title': { en: 'My Events', zh: '我的活动' },
  'myEvents.loading': { en: 'Loading your events...', zh: '正在加载您的活动…' },
  'myEvents.notifications': { en: 'Notifications', zh: '通知' },
  'myEvents.notification': { en: 'Notification', zh: '通知' },
  'myEvents.noNotifications': { en: 'No notifications', zh: '暂无通知' },
  'myEvents.updatesHere': { en: "You'll see updates here", zh: '更新会显示在这里' },
  'myEvents.nt.spotAvailable': { en: 'Spot Available', zh: '有空位了' },
  'myEvents.nt.registrationConfirmed': { en: 'Registration Confirmed', zh: '报名已确认' },
  'myEvents.nt.waitlistJoined': { en: 'Joined Waitlist', zh: '已加入候补' },
  'myEvents.nt.waitlistCancelled': { en: 'Waitlist Cancelled', zh: '已取消候补' },
  'myEvents.nt.registrationCancelled': { en: 'Registration Cancelled', zh: '报名已取消' },
  'myEvents.nt.cancelledRefund': { en: 'Cancelled - Refund Requested', zh: '已取消 - 已申请退款' },
  'myEvents.nt.waitlistPromotion': { en: 'Promoted from Waitlist', zh: '候补转正' },
  'myEvents.nt.paymentReminder': { en: 'Payment Reminder', zh: '付款提醒' },
  'myEvents.nt.paymentApproved': { en: 'Payment Approved', zh: '付款已通过' },
  'myEvents.nt.paymentRejected': { en: 'Payment Rejected', zh: '付款被拒绝' },
  'myEvents.nt.eventReminder': { en: 'Event Reminder', zh: '活动提醒' },
  'myEvents.nt.eventUpdated': { en: 'Event Updated', zh: '活动已更新' },
  'myEvents.nt.eventCancelled': { en: 'Event Cancelled', zh: '活动已取消' },
  'myEvents.nt.refundProcessed': { en: 'Refund Processed', zh: '退款已处理' },
  'myEvents.nt.checkinReminder': { en: 'Check-in Available', zh: '可以签到了' },
  'myEvents.tabUpcoming': { en: 'Upcoming ({count})', zh: '即将参加 ({count})' },
  'myEvents.tabPast': { en: 'Past Events ({count})', zh: '往期活动 ({count})' },
  'myEvents.tabCancelled': { en: 'Cancelled ({count})', zh: '已取消 ({count})' },
  'myEvents.labelUpcoming': { en: 'Upcoming', zh: '即将开始' },
  'myEvents.labelPast': { en: 'Past', zh: '往期' },
  'myEvents.noEventsFound': { en: 'No events found', zh: '未找到活动' },
  'myEvents.emptyUpcoming': { en: 'You have no upcoming events. Browse available events to join!', zh: '您还没有即将参加的活动，去看看可报名的活动吧！' },
  'myEvents.emptyPast': { en: 'You have no past events yet.', zh: '您还没有往期活动。' },
  'myEvents.emptyCancelled': { en: 'You have no cancelled events.', zh: '您没有已取消的活动。' },
  'myEvents.browseEvents': { en: 'Browse Events', zh: '浏览活动' },
  'myEvents.inDay': { en: '{count} day', zh: '{count} 天' },
  'myEvents.inDays': { en: '{count} days', zh: '{count} 天' },
  'myEvents.durMinutes': { en: '{count} minutes', zh: '{count} 分钟' },
  'myEvents.durHour': { en: '{count} hour', zh: '{count} 小时' },
  'myEvents.durHours': { en: '{count} hours', zh: '{count} 小时' },
  'myEvents.paid': { en: 'Paid:', zh: '已付：' },
  'myEvents.copyRef': { en: 'Copy reference', zh: '复制参考号' },
  'myEvents.paymentRequired': { en: 'Payment required', zh: '需要付款' },
  'myEvents.deadlinePassed': { en: 'Deadline passed', zh: '已过截止时间' },
  'myEvents.dueInHM': { en: 'Due in {h}h {m}m', zh: '{h} 小时 {m} 分钟后截止' },
  'myEvents.dueInM': { en: 'Due in {m}m', zh: '{m} 分钟后截止' },
  'myEvents.proofSubmittedAwaiting': { en: 'Payment proof submitted - awaiting approval', zh: '付款凭证已提交 - 等待审核' },
  'myEvents.proofRequired': { en: 'Payment proof required', zh: '需要上传付款凭证' },
  'myEvents.uploadProof': { en: 'Upload Proof', zh: '上传凭证' },
  'myEvents.waitlistPos': { en: 'Waitlist #{n}', zh: '候补第 {n} 位' },
  'myEvents.notifiedWhenOpens': { en: '· Notified when spot opens', zh: '· 有名额时会通知您' },
  'myEvents.services': { en: 'Services:', zh: '服务：' },
  'myEvents.namesLabel': { en: 'Names:', zh: '姓名：' },
  'myEvents.notesLabel': { en: 'Notes:', zh: '备注：' },
  'myEvents.directions': { en: 'Directions', zh: '导航' },
  'myEvents.checkIn': { en: 'Check In', zh: '签到' },
  'myEvents.checkinHint': { en: 'Check-in opens 30 min before event · Location required', zh: '活动开始前 30 分钟开放签到 · 需开启定位' },
  'myEvents.uploadProofTitle': { en: 'Upload Payment Proof', zh: '上传付款凭证' },
  'myEvents.uploadProofDesc': { en: 'Please upload a screenshot or photo of your payment confirmation.', zh: '请上传付款确认的截图或照片。' },
  'myEvents.paymentReference': { en: 'Payment Reference:', zh: '付款参考号：' },
  'myEvents.compressing': { en: 'Compressing image...', zh: '正在压缩图片…' },
  'myEvents.choosePaymentScreenshot': { en: 'Choose Payment Screenshot', zh: '选择付款截图' },
  'myEvents.previewLabel': { en: 'Preview:', zh: '预览：' },
  'myEvents.fileSize': { en: 'File size: {size}', zh: '文件大小：{size}' },
  'myEvents.uploading': { en: 'Uploading...', zh: '上传中…' },
  'myEvents.upload': { en: 'Upload', zh: '上传' },
  'myEvents.cancelEvent': { en: 'Cancel Event', zh: '取消报名' },
  'myEvents.qmark': { en: '?', zh: '' },
  'myEvents.loseWaitlistPos': { en: '• You will lose your position in the waitlist', zh: '• 您将失去候补名单中的位置' },
  'myEvents.noPaymentYet': { en: '• No payment has been processed yet', zh: '• 尚未产生任何付款' },
  'myEvents.checkinTitle': { en: 'Check In to Event', zh: '活动签到' },
  'myEvents.checkinWelcome': { en: 'Welcome and join with us now!', zh: '欢迎！现在就加入我们吧！' },
  'myEvents.checkinTooFarMsg': { en: 'You must be within 200 meters of the venue to check in. Please move closer to the venue location and try again.', zh: '您需要在场馆 200 米范围内才能签到，请靠近场馆后重试。' },
  'myEvents.distance': { en: 'Distance: {m}m away', zh: '距离：{m} 米' },
  'myEvents.distanceUnknown': { en: 'Unable to determine your distance from venue', zh: '无法确定您与场馆的距离' },
  'myEvents.tooFarToCheckin': { en: 'Too Far to Check In', zh: '距离太远，无法签到' },
  'myEvents.badgeProofSubmitted': { en: 'Proof Submitted', zh: '凭证已提交' },
  'myEvents.badgeRecentlyPromoted': { en: 'Recently Promoted', zh: '刚刚转正' },
  'myEvents.badgeEventStarted': { en: 'Event Started', zh: '活动已开始' },
  'myEvents.badgeUnknown': { en: 'Unknown', zh: '未知' },
  'myEvents.errClearNotifications': { en: 'Failed to clear notifications', zh: '清除通知失败' },
  'myEvents.errLoadingEvents': { en: 'Error loading your events', zh: '加载您的活动出错' },
  'myEvents.refCopied': { en: 'Payment reference copied to clipboard!', zh: '付款参考号已复制！' },
  'myEvents.refCopyFailed': { en: 'Failed to copy payment reference', zh: '复制付款参考号失败' },
  'myEvents.selectImageFile': { en: 'Please select an image file', zh: '请选择图片文件' },
  'myEvents.imageCompressed': { en: 'Image compressed to {size}', zh: '图片已压缩至 {size}' },
  'myEvents.compressFailed': { en: 'Failed to compress image. Please try another image.', zh: '图片压缩失败，请换一张图片。' },
  'myEvents.selectImageFirst': { en: 'Please select an image first', zh: '请先选择图片' },
  'myEvents.proofUploaded': { en: 'Payment proof uploaded successfully!', zh: '付款凭证上传成功！' },
  'myEvents.uploadFailed': { en: 'Upload failed: {error}', zh: '上传失败：{error}' },
  'myEvents.locDenied': { en: 'Location access denied. Please enable location services and try again.', zh: '位置权限被拒绝，请开启定位服务后重试。' },
  'myEvents.locUnavailable': { en: 'Location information unavailable. Please try again.', zh: '无法获取位置信息，请重试。' },
  'myEvents.locTimeout': { en: 'Location request timed out. Please try again.', zh: '定位请求超时，请重试。' },
  'myEvents.locUnknown': { en: 'Unable to get your location. Please try again.', zh: '无法获取您的位置，请重试。' },
  'myEvents.geoUnsupported': { en: 'Geolocation is not supported by this browser.', zh: '此浏览器不支持定位功能。' },
  'myEvents.waitlistCancelledOk': { en: 'Waitlist cancelled successfully.', zh: '已成功取消候补。' },
  'myEvents.checkinError': { en: 'Error checking in. Please try again.', zh: '签到出错，请重试。' },

  // ── Profile: edit form, logout, notifications ────────────────────────────────
  'profile.fullNameLabel': { en: 'Full Name', zh: '姓名' },
  'profile.genderLabel': { en: 'Gender', zh: '性别' },
  'profile.other': { en: 'Other', zh: '其他' },
  'profile.preferNotToSay': { en: 'Prefer not to say', zh: '不愿透露' },
  'profile.notSet': { en: 'Not set', zh: '未设置' },
  'profile.saving': { en: 'Saving...', zh: '保存中…' },
  'profile.saveChanges': { en: 'Save Changes', zh: '保存修改' },
  'profile.sending': { en: 'Sending…', zh: '发送中…' },
  'profile.checking': { en: 'Checking…', zh: '验证中…' },
  'profile.errNameRequired': { en: 'Please enter your name', zh: '请输入您的姓名' },
  'profile.errUpdateRetry': { en: 'Error updating profile. Please try again.', zh: '更新资料出错，请重试。' },
  'profile.updateError': { en: 'Error updating profile', zh: '更新资料出错' },
  'profile.updatedCanRegister': { en: 'Profile updated successfully! You can now register for events.', zh: '资料更新成功！现在可以报名活动了。' },
  'profile.updated': { en: 'Profile updated successfully!', zh: '资料更新成功！' },
  'profile.logoutConfirm': { en: 'Are you sure you want to logout?', zh: '确定要退出登录吗？' },
  'profile.logoutError': { en: 'Error logging out', zh: '退出登录出错' },
  'profile.codeSent': { en: 'Verification code sent to {email}', zh: '验证码已发送至 {email}' },
  'profile.codeWait': { en: 'Please wait a bit before requesting another code', zh: '请稍等片刻再重新获取验证码' },
  'profile.emailInUse': { en: 'This email is already associated with another account', zh: '该邮箱已关联其他账户' },
  'profile.codeSendFailed': { en: 'Could not send verification code. Please try again.', zh: '验证码发送失败，请重试。' },
  'profile.emailVerifiedToast': { en: 'Email verified!', zh: '邮箱验证成功！' },
  'profile.codeInvalid': { en: "That code didn't work — please try again", zh: '验证码无效，请重试' },
  'profile.codeConfirmError': { en: 'Something went wrong confirming that code. Please try again.', zh: '验证码确认出错，请重试。' },
  'profile.completeToContinue': { en: 'Please complete your profile to continue using the app.', zh: '请完善个人资料以继续使用。' },
  'profile.avatarUpdated': { en: 'Avatar updated!', zh: '头像已更新！' },
  'profile.socialSaved': { en: 'Social profile saved!', zh: '社交资料已保存！' },
  'profile.saveError': { en: 'Error saving', zh: '保存出错' },
  // keys already referenced in code (with `|| 'fallback'`) but previously missing
  'profile.avatarUploadError': { en: 'Failed to update avatar. Please try again.', zh: '头像更新失败，请重试。' },
  'profile.changeAvatar': { en: 'Change avatar', zh: '更换头像' },
  'profile.uploadingAvatar': { en: 'Uploading...', zh: '上传中…' },
  'event.onWaitlist': { en: 'On waitlist', zh: '候补中' },
};

function build(langKey) {
  const out = {};
  for (const k of Object.keys(dict)) {
    const entry = dict[k];
    out[k] = entry[langKey] != null ? entry[langKey] : entry.en;
  }
  return out;
}

export const translations = {
  en: build('en'),
  zh: build('zh'),
};

export { dict };
export default translations;